import apiClient from "../../client/apiClient";
import { appendQueryParams } from "../../utils";

export type TransportShiftStatus = "active" | "inactive";

export interface TransportShift {
  id: string;
  key: string;
  name: string;
  status: TransportShiftStatus;
  createdAt?: string;
  updatedAt?: string;
}

export interface PaginationData {
  currentPage: number;
  hasNextPage: boolean;
  hasPrevPage: boolean;
  limit: number;
  total: number;
  totalPages: number;
}

export interface TransportShiftsResponse {
  data: any[];
  pagination: PaginationData;
}

const TRANSPORT_SHIFT_ENDPOINT = {
  SHIFTS: "/transport/shifts",
};

type ListTransportShiftsParams = {
  page?: number;
  limit?: number;
  searchText?: string;
  status?: string;
  sortBy?: string;
  sortOrder?: string;
};

export const getAllTransportShifts = async ({
  page = 1,
  limit = 20,
  searchText,
  status,
  sortBy,
  sortOrder,
}: ListTransportShiftsParams = {}): Promise<TransportShiftsResponse> => {
  const response = await apiClient({
    url: appendQueryParams(TRANSPORT_SHIFT_ENDPOINT.SHIFTS, {
      page,
      limit,
      searchText,
      status,
      sortBy,
      sortOrder,
    }),
    method: "GET",
  });

  return response.data;
};

type CreateTransportShiftPayload = {
  name: string;
  status?: TransportShiftStatus;
};

export const createTransportShift = async (payload: CreateTransportShiftPayload) => {
  const response = await apiClient({
    url: TRANSPORT_SHIFT_ENDPOINT.SHIFTS,
    method: "POST",
    data: { ...payload, status: payload.status || "active" },
  });

  return response.data;
};

type UpdateTransportShiftPayload = {
  name: string;
  status: TransportShiftStatus;
};

export const updateTransportShift = async (
  shiftId: string,
  payload: UpdateTransportShiftPayload
) => {
  const response = await apiClient({
    url: `${TRANSPORT_SHIFT_ENDPOINT.SHIFTS}/${shiftId}`,
    method: "PUT",
    data: payload,
  });

  return response.data;
};
